import axios from 'axios';
import { handleResponse, handleError } from './Response';

const BASE_URL = process.env.REACT_APP_BASE_URL || '/mlapi';

const config = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
}

export const apiClient = axios.create({
    baseURL: BASE_URL,
});

apiClient.interceptors.request.use(c => {
    const t = localStorage.getItem('token');
    if (t) c.headers.Authorization = `Bearer ${t}`;
    console.log('[API]', c.method?.toUpperCase(), `${c.baseURL}${c.url}`);
    return c;
});

// 401 from sign-in endpoints means bad credentials, not an expired session.
const AUTH_ENDPOINT = /account\/(login|2fa\/verify-login|2fa\/resend-login-code)$/;

apiClient.interceptors.response.use(
    r => r,
    err => {
        if (err.response?.status === 401 && !AUTH_ENDPOINT.test(err.config?.url ?? '')) {
            localStorage.removeItem('token');
            window.location = '/login'
        }
        return Promise.reject(err);
    }
);

const configForFile = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      //  'Authorization': 'Bearer ' + localStorage.getItem('token'),
    }
}
 
/** @param {string} resource */
const download = (resource) => {
    return apiClient
        .get(`${resource}`, { responseType: 'blob' });
};

/** @param {string} resource */
/** @param {object} model */
const downloadPost = (resource, model) => {
    return apiClient
        .post(`${resource}`, model, { responseType: 'blob' });
};

/** @param {string} resource */
const get = (resource) => {
    return apiClient
        .get(`${resource}`, config)
        .then(handleResponse)
        .catch(handleError);
};
 
/** @param {string} resource */
/** @param {string} id */
const getSingle = (resource, id) => {
    return apiClient
        .get(`/${resource}?id=${id}`, config)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {string} search */
const search = (resource, search) => {
    return apiClient
        .get(`/${resource}?search=${search}`, config)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {object} model */
/** @param {object} extendedConfig */
const post = (resource, model, extendedConfig = {}) => {
    return apiClient
        .post(`/${resource}`, model, {...config, ...extendedConfig})
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param resource
 @param {object} model */
const put = (resource, model) => {
    return apiClient
        .put(`/${resource}`, model, config)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param resource
 @param {object} model */
const patch = (resource, model) => {
    return apiClient
        .patch(`/${resource}`, model, config)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param resource
 @param {string} id */
const remove = (resource, id) => {
    return apiClient
        .delete(`/${resource}/${id}`, config)
        .then(handleResponse)
        .catch(handleError);
};


const postMultipart = (resource, formData) => {
    return apiClient
        .post(`/${resource}`, formData)
        .then(handleResponse)
        .catch(handleError);
};

export const apiProvider = {
    get,
    getSingle,
    search,
    post,
    postMultipart,
    put,
    remove,
    download,
    downloadPost,
    patch,
    BASE_URL,
    config
};